export default class Courses {
	constructor () {
		this.addHandlers()
	}

	addHandlers () {
		document.getElementById('toggleCourseSidebar').addEventListener('click', function (e) {
			e.preventDefault()
			e.stopPropagation()
			document.getElementById('courseSidebar').classList.toggle('hidden')
		})
	}
}
